import { Box, Divider, Skeleton, SkeletonText, Stack, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import _ from "lodash";

const DEFAULT_NUMBER = 1;

interface INewsSkeletenProps {
	numberOfSkeletons?: number;
}

const NewsSkeleton = (props: INewsSkeletenProps) => {
	return (
		<Stack divider={<Divider />} gap={ThemeSpaceVariable.Medium} m={ThemeSpaceVariable.Medium}>
			{_.range(props.numberOfSkeletons ?? DEFAULT_NUMBER).map((_x, i) => (
				<Box key={i}>
					<Skeleton h="20px" />
					<SkeletonText
						mt={ThemeSpaceVariable.Medium}
						noOfLines={4}
						gap={ThemeSpaceVariable.Small}
						height={ThemeSpaceVariable.Small}
					/>
				</Box>
			))}
		</Stack>
	);
};

export default NewsSkeleton;
